import React, { useEffect, useState } from "react";
import "../App.css";

function Careers() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Replace 14 with your actual page ID
    fetch("https://family-barbers.com/wp-json/acf/v3/pages/14")
      .then((res) => res.json())
      .then((json) => setData(json.acf))
      .catch((err) => console.error("Error fetching ACF data:", err));
  }, []);

  if (!data) return null;

  return (
    <div id="careers" className="section">
      <div className="careers-container">
        <h1>{data.careers_heading || "Careers"}</h1>
        <p>{data.careers_intro || "Default intro text about careers."}</p>

        <div className="careers-container-2">
          <div className="career-positions-1">
            <h2>{data.part_time_heading || "Part Time Positions"}</h2>
            <ul>
              <li>{data.part_time_1 || "Part Time licensed hairstylist (Should be able to do braids and locs, chemical treatment is a plus)"}</li>
              <li>{data.part_time_2 || "Part Time Junior/Senior Barber"}</li>
              <li>{data.part_time_3 || "Part Time Receptionist"}</li>
            </ul>
          </div>

          <div className="career-positions-2">
            <h2>{data.full_time_heading || "Full Time Positions"}</h2>
            <ul>
              <li>{data.full_time_1 || "Full Time licensed hairstylist (Should be able to do braids and locs, chemical treatment is a plus)"}</li>
              <li>{data.full_time_2 || "Full Time Junior/Senior Barber"}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Careers;
